<template>
  <div class="form-group">
    <label v-if="label" v-safe-html="label" :for="id"></label>
    <input
      v-bind="$attrs"
      :id="id"
      :type="type"
      :value="formattedValue"
      @input="onInput"
      :placeholder="placeholder"
      :class="[className, { 'is-invalid': error }]"
      :style="{ width: width }"
      :readonly="readonly"
      class="form-control"
    />
    <div v-if="error" class="invalid-feedback">{{ error }}</div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    modelValue: [String, Number],
    label: { type: String, required: true },
    id: { type: String, required: true },
    type: { type: String, default: 'text' },
    placeholder: { type: String, default: '' },
    mask: { type: String, default: null },
    className: { type: String, default: '' },
    error: { type: String, default: '' },
    width: { type: String, default: '100%' },
    readonly: { type: Boolean, default: false },
  },
  computed: {
    formattedValue() {
      if (!this.mask || !this.modelValue) return this.modelValue;
      return this.applyMask(this.modelValue, this.mask);
    },
  },
  methods: {
    onInput(event) {
      const rawValue = event.target.value;
      const maskedValue = this.mask ? this.applyMask(rawValue, this.mask) : rawValue;
      this.$emit('update:modelValue', maskedValue);
    },

    applyMask(value, mask) {
      const onlyDigits = (value || '').toString().replace(/\D/g, '');

      const masks = {
        cpf: () => {
          const v = onlyDigits.slice(0, 11);
          return v
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d{1,2}).*/, '$1-$2');
        },

        telefone: () => {
          const v = onlyDigits.slice(0, 11);

          if (v.length <= 10) {
            return v
              .replace(/(\d{2})(\d)/, '($1) $2')
              .replace(/(\d{4})(\d)/, '$1-$2');
          }

          return v
            .replace(/(\d{2})(\d)/, '($1) $2')
            .replace(/(\d{5})(\d)/, '$1-$2');
        },

        celular: () => {
          const v = onlyDigits.slice(0, 11);

          if (v.length <= 10) {
            return v
              .replace(/(\d{2})(\d)/, '($1) $2')
              .replace(/(\d{4})(\d)/, '$1-$2');
          }

          return v
            .replace(/(\d{2})(\d)/, '($1) $2')
            .replace(/(\d{5})(\d)/, '$1-$2');
        },

        cep: () => {
          const v = onlyDigits.slice(0, 8);
          return v
            .replace(/(\d{5})(\d{1,3}).*/, '$1-$2');
        },

        cnpj: () => {
          const v = onlyDigits.slice(0, 14);
          return v
            .replace(/^(\d{2})(\d)/, '$1.$2')
            .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
            .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4')
            .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d{1,2}).*/, '$1.$2.$3/$4-$5');
        },
      };

      return masks[mask] ? masks[mask]() : value;
    },
  },
};
</script>

<style>
.form-group {
  margin-bottom: 0.5rem;
}
.invalid-feedback {
  color: #dc3545;
  font-size: 0.8rem;
  margin-top: 0.25rem;
}
.form-control,
select.form-control {
  padding: 0.25rem 0.5rem;
  font-size: 0.73rem;
  height: 25px;
  border-radius: 4px;
  box-sizing: border-box;
  width: 100%;
  appearance: none;
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
}
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.25rem;
  margin-top: 0.5rem;
}
label {
  font-size: 0.85rem;
  margin-bottom: 0.2rem;
  display: block;
}
</style>